<!--
 * @Author: yezi
 * @Date: 2020-05-26 11:45:04
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 15:01:40
 * @Description:
-->
<template>
  <div class="content">
    <div class="cItem">
      <!-- <van-nav-bar :title="info.title"
                   left-arrow
                   @click-left="back" /> -->
      <!-- <div style="display:flex;align-items: center; padding: 0 .3rem" @click="back">
        <van-icon name="arrow-left" size="22px" style="margin-right:0.1rem"/>
        <P class="title">{{}}</P>
      </div> -->
      <video v-if="info.sources !== ''"
             :src="info.sources"
             controls="controls"
             controlslist="nodownload"
             playsinline
             :poster="info.page_img"
             class="video" />
      <div v-if="info.video_content !== ''"
           v-html="info.video_content"
           style="padding: 0.4rem .2rem;font-size:.3rem"></div>
           <div v-if="info.content !== '' && !info.video_content"
           v-html="info.content"
           style="padding: 0.4rem .2rem;font-size:.3rem"></div>
      <div class="back"
           @click="goBack">返回目录</div>
    </div>
  </div>
</template>

<script>
import { getFirmInfo } from '../api/wap'
export default {
  name: '',
  components: {},
  data () {
    return {
      info: {},
      id: '',
      key: ''
    }
  },
  created () {
    // this.sources = this.$route.query.sources
    // this.title = this.$route.query.title
    // this.video_page = this.$route.query.video_page
    this.id = this.$route.query.id
    this.key = this.$route.query.key
    // console.log(this.$route.query.id)
    this.getDetail()
  },

  methods: {
    back () {
      this.$router.back()
    },
    getDetail () {
      getFirmInfo({ h5_id: this.id, get_key: this.key }).then(res => {
        console.log(res)
        if (res.result.detail.video_content !== '' && res.result.detail.video_content !== null) {
          res.result.detail.video_content = res.result.detail.video_content.replace(/<img/g, "<img style='max-width:100%;height:auto;'").replace(/<h1/g, "<h1 style='font-size: 0.36rem'")
        }
        this.info = res.result.detail
        console.log(this.info.content, this.info)
      })
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.content {
  /* padding-bottom: 0.5rem; */
  margin: 0 0.2rem;
}
.tItem {
  margin-top: 0.59rem;
  width: 100%;
  padding: 0.4rem;
  border-radius: 0.16rem;
  box-shadow: 0rem 0rem 0.46rem 0rem rgba(4, 0, 0, 0.13);
}
.tItem p {
  font-size: 0.4rem;
  font-weight: bold;
  color: #121212;
}
.listTitle {
  position: fixed;
  bottom: 37%;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 4000;
}
.listTitle label {
  width: 1.37rem;
  height: 0.73rem;
  background: rgba(250, 170, 34, 1);
  border-radius: 0.16rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.seriesList {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 0.2rem;
  padding: 0.3rem 0;
  overflow-x: scroll;
}
.seriesItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cItem {
  margin-top: 0.59rem;
}
.cItem p {
  color: #121212;
  font-size: 0.34rem;
  font-weight: bold;
}
.cItem video {
  margin-top: 0.3rem;
  width: 7.1rem;
  background-color: #121212;
}
.videoJust {
  width: 7.1rem;
  height: 7.1rem;
}
.videoWide {
  width: 7.1rem;
  height: 4rem;
}
.video {
  width: 100%;
  height: 3.6rem;
  margin-top: 0.3rem;
}
.cItem >>> .van-nav-bar .van-icon {
  color: #000;
}
.back {
  position: fixed;
  bottom: 20%;
  right: 3%;
  width: 1.37rem;
  height: 0.73rem;
  background: rgba(250, 170, 34, 1);
  border-radius: 0.16rem;
  color: #fff;
  font-size: 0.32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  text-align: center;
  line-height: 0.73rem;
  white-space: nowrap;
}
</style>
